<template>
    <div v-bind="$attrs" v-if="dataLoad.includes('Carregando')" class="animate-pulse flex space-x-4">
        <div class="flex-1 space-y-6 py-1">
            <div class="space-y-3">
                <div class="grid grid-cols-3 gap-4">
                    <div class="h-2 bg-gray-400 rounded col-span-2"></div>
                    <div class="h-2 bg-gray-400 rounded col-span-1"></div>
                    <div class="h-2 bg-gray-400 rounded col-span-1"></div>
                    <div class="h-2 bg-gray-400 rounded col-span-2"></div>
                    <div class="h-2 bg-gray-400 rounded col-span-1"></div>
                    <div class="h-2 bg-gray-400 rounded col-span-1"></div>
                    <div class="h-2 bg-gray-400 rounded col-span-1"></div>
                </div>
                <div class="h-2 bg-gray-400 rounded"></div>
            </div>
        </div>
    </div>
    <div v-else class="font-poppins text-lg text-purple-800 text-center">
        {{ dataLoad }}
    </div>
</template>

<script setup>
defineProps({
    dataLoad: {
        type: String,
        default: 'Carregando',
        required: true,
    }
})
</script>
